export default "__VITE_ASSET__bic$kfpl__"